import * as actionTypes from '../types/survey';

const initialState = {
  adding: false,
  addRequest: false,
  addSurveyData: {},
  getRequest: false,
  getting: false,
  listSurveyResult: [],
  listSurveys: [],
  loading: false,
  saveRequest: false,
  surveyData: []
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SURVEY_LIST:
      return {
        ...state,
        loading: true
      };
    case actionTypes.SURVEY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        surveyData: payload
      };
    case actionTypes.SURVEY_LIST_FAIL:
      return {
        ...state,
        loading: false
      };
    case actionTypes.SAVE_SURVEY_RESULT:
      return {
        ...state,
        loading: true,
        saveRequest: false
      };
    case actionTypes.SAVE_SURVEY_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        saveRequest: true
      };
    case actionTypes.SAVE_SURVEY_RESULT_FAIL:
      return {
        ...state,
        loading: false
      };
    case actionTypes.GET_LIST_SURVEYS:
      return {
        ...state,
        getting: true,
        getRequest: false
      };
    case actionTypes.GET_LIST_SURVEYS_SUCCESS:
      return {
        ...state,
        getting: false,
        getRequest: true,
        listSurveys: payload
      };
    case actionTypes.GET_LIST_SURVEYS_FAIL:
      return {
        ...state,
        getting: false,
        getRequest: false
      };
    case actionTypes.GET_SURVEY_RESULT:
      return {
        ...state,
        getting: true,
        getRequest: false
      };
    case actionTypes.GET_SURVEY_RESULT_SUCCESS:
      return {
        ...state,
        getting: false,
        getRequest: true,
        listSurveyResult: payload
      };
    case actionTypes.GET_SURVEY_RESULT_FAIL:
      return {
        ...state,
        getting: false,
        getRequest: false
      };
    case actionTypes.ADD_SURVEY:
      return {
        ...state,
        adding: true,
        addRequest: false,
        addSurveyData: payload
      };
    case actionTypes.ADD_SURVEY_SUCCESS:
      return {
        ...state,
        adding: false,
        addRequest: true,
        addSurveyData: {}
      };
    case actionTypes.ADD_SURVEY_FAIL:
      return {
        ...state,
        adding: false,
        addRequest: false,
        addSurveyData: {}
      };
    case actionTypes.TOGGLE_ACTIVATION_SURVEY:
      return {
        ...state,
        getting: true,
        getRequest: false
      };
    case actionTypes.TOGGLE_ACTIVATION_SURVEY_SUCCESS:
      return {
        ...state,
        getting: false,
        getRequest: true,
        listSurveys: payload
      };
    case actionTypes.TOGGLE_ACTIVATION_SURVEY_FAIL:
      return {
        ...state,
        getting: false,
        getRequest: false
      };
    default:
      return state;
  }
};

export default reducer;
